<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showOrder") }}</h4>
    </div>

    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <h2>{{ $t("PLACEHOLDERS.showOrder") }}</h2>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderNum')"
            v-model.trim="donation.id"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderCreate')"
            v-model.trim="donation.created_at"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderStatus')"
            v-model.trim="donation._status"
            disabled
          />

          <h2>{{ $t("PLACEHOLDERS.userData") }}</h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientName')"
            v-model.trim="donation.donor_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientPhone')"
            v-model.trim="donation.donor_mobile"
            disabled
          />

          <h2>{{ $t("PLACEHOLDERS.mosques_management") }}</h2>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="mosque.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="mosque.address"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.map_location')"
            :value="
              mosque.lat && mosque.lng ? `${mosque.lat}, ${mosque.lng}` : '-'
            "
            disabled
          />

          <div
            class="col-12"
            v-if="
              donation.can_assign_mosque &&
              $can('donations assign mosque', 'donations')
            "
          >
            <div class="row align-items-end">
              <base-select-input
                col="8"
                :optionsList="mosquesList"
                :placeholder="$t('PLACEHOLDERS.select_mosque')"
                v-model="selectedMosque"
              />
              <div class="col-lg-4 my-5">
                <button
                  class="btn submit_btn w-100"
                  type="button"
                  :disabled="loadingAssignMosque || !selectedMosque"
                  @click="assignMosque"
                >
                  {{ $t("PLACEHOLDERS.assign_mosque") }}
                </button>
              </div>
            </div>
          </div>

          <h2>{{ $t("PLACEHOLDERS.supervisors") }}</h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="supervisor.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="supervisor.mobile"
            disabled
          />

          <div
            class="col-12"
            v-if="
              donation.can_assign_supervisor &&
              $can('donations assign supervisor', 'donations')
            "
          >
            <div class="row align-items-end">
              <base-select-input
                col="8"
                :optionsList="supervisorsList"
                :placeholder="$t('PLACEHOLDERS.select_supervisor')"
                v-model="selectedSupervisor"
              />
              <div class="col-lg-4 my-5">
                <button
                  class="btn submit_btn w-100"
                  type="button"
                  :disabled="loadingAssignSupervisor || !selectedSupervisor"
                  @click="assignSupervisor"
                >
                  {{ $t("PLACEHOLDERS.assign_supervisor") }}
                </button>
              </div>
            </div>
          </div>

          <h2>{{ $t("PLACEHOLDERS.ordersList") }}</h2>
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("PLACEHOLDERS.type") }}</th>
                    <th>{{ $t("PLACEHOLDERS.name") }}</th>
                    <th>{{ $t("PLACEHOLDERS.price") }}</th>
                    <th>{{ $t("PLACEHOLDERS.quantatyy") }}</th>
                    <th>{{ $t("TABLES.subscriptions.Totalorder") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in donation.items"
                    :key="item.id || index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{
                        item.type === "package"
                          ? $t("PLACEHOLDERS.package_number")
                          : $t("PLACEHOLDERS.product")
                      }}
                    </td>
                    <td>{{ getItemName(item) }}</td>
                    <td>{{ item.price || "-" }}</td>
                    <td>{{ item.quantity || "-" }}</td>
                    <td>{{ item.total || "-" }}</td>
                  </tr>
                  <tr v-if="!donation.items.length">
                    <td colspan="6" class="text-center">
                      {{ $t("TABLES.noData") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <h2>{{ $t("PLACEHOLDERS.priceData") }}</h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalOrderPrice')"
            v-model.trim="donation.total"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowDonation",

  data() {
    return {
      loadingAssignMosque: false,
      loadingAssignSupervisor: false,

      donation: {
        id: null,
        donor_name: null,
        donor_mobile: null,
        total: null,
        _status: null,
        created_at: null,
        can_assign_mosque: false,
        can_assign_supervisor: false,
        items: [],
      },

      mosque: {
        id: null,
        name: null,
        address: null,
        lat: null,
        lng: null,
      },

      supervisor: {
        id: null,
        name: null,
        mobile: null,
      },

      mosquesList: [],
      supervisorsList: [],
      selectedMosque: null,
      selectedSupervisor: null,
    };
  },

  methods: {
    getItemName(item) {
      if (item.type === "package") {
        return item.package?.name || "-";
      }
      return item.product?.name || "-";
    },

    async getDataToShow() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `donations/${this.$route.params.id}`,
        });

        const donation = res.data?.data?.donation || {};
        this.donation = {
          id: donation.id,
          donor_name: donation.donor_name,
          donor_mobile: donation.donor_mobile,
          total: donation.total,
          _status: donation._status,
          created_at: donation.created_at,
          can_assign_mosque: donation.can_assign_mosque,
          can_assign_supervisor: donation.can_assign_supervisor,
          items: donation.items || [],
        };

        this.mosque = donation.mosque || {
          id: null,
          name: null,
          address: null,
          lat: null,
          lng: null,
        };

        this.supervisor = donation.supervisor || {
          id: null,
          name: null,
          mobile: null,
        };
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || this.$t("TABLES.noData")
        );
      }
    },

    async getMosques() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "mosques",
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
          },
        });
        const rows = res.data?.data?.data || res.data?.data || [];
        this.mosquesList = rows.map((item) => ({
          ...item,
          name: item.name || item.name_ar || item.name_en,
        }));
      } catch (error) {
        this.mosquesList = [];
      }
    },

    async getSupervisors() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "supervisors",
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
          },
        });
        const rows = res.data?.data?.data || res.data?.data || [];
        this.supervisorsList = rows.map((item) => ({
          ...item,
          name: item.name || item.full_name,
        }));
      } catch (error) {
        this.supervisorsList = [];
      }
    },

    async assignMosque() {
      if (!this.selectedMosque?.id) {
        return;
      }

      this.loadingAssignMosque = true;
      try {
        const res = await this.$axios({
          method: "POST",
          url: `donations/${this.$route.params.id}/assign-mosque`,
          data: {
            mosque_id: this.selectedMosque.id,
          },
        });
        this.$message.success(
          res.data?.message || this.$t("MESSAGES.savedSuccessfully")
        );
        this.selectedMosque = null;
        this.getDataToShow();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || this.$t("TABLES.noData")
        );
      } finally {
        this.loadingAssignMosque = false;
      }
    },

    async assignSupervisor() {
      if (!this.selectedSupervisor?.id) {
        return;
      }

      this.loadingAssignSupervisor = true;
      try {
        const res = await this.$axios({
          method: "POST",
          url: `donations/${this.$route.params.id}/assign-supervisor`,
          data: {
            supervisor_id: this.selectedSupervisor.id,
          },
        });
        this.$message.success(
          res.data?.message || this.$t("MESSAGES.savedSuccessfully")
        );
        this.selectedSupervisor = null;
        this.getDataToShow();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || this.$t("TABLES.noData")
        );
      } finally {
        this.loadingAssignSupervisor = false;
      }
    },
  },

  created() {
    this.getDataToShow();
    this.getMosques();
    this.getSupervisors();
  },
};
</script>
